import React from 'react';
import styled from 'styled-components';
import { Drawer, makeStyles } from '@material-ui/core';
import Datatable from '../Datatable';

const ZindexSetter = styled.div`
  position: absolute;
  top: 20px;
  left: 10px;
  height: 38px;
  cursor: pointer;
  width: 160px;
  z-index: 5;
  background-color: #9ec73c !important;
  border-radius: 5px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Heebo, sans-serif;
  font-size: 14px;
`;

const SidePanel = ({ store, handleClick }) => {
  const [state, setState] = React.useState({
    left: false
  });
  const useStyles = makeStyles({
    list: {
      width: 'auto',
      height: 150
    },
    fullList: {
      width: 'auto'
    },
    root: {
      maxWidth: '100vw'
    }
  });
  const toggleDrawer = (side, open) => {
    setState({ ...state, [side]: open });
  };
  const classes = useStyles();

  const sideList = (side) => (
    <div className={classes.list} role="presentation">
      <Datatable
        store={store}
        handleClick={handleClick}
        toggleDrawer={toggleDrawer}
      />
    </div>
  );

  return (
    <React.Fragment>
      <ZindexSetter onClick={() => toggleDrawer('left', true)}>
        CITY INDEX
      </ZindexSetter>
      <Drawer
        PaperProps={{ classes: classes }}
        open={state.left}
        onClose={() => toggleDrawer('left', false)}
      >
        {sideList('left')}
      </Drawer>
    </React.Fragment>
  );
};

export default SidePanel;
